import WebsiteTemplate from "../_local/components/NewCards/WebsiteTemplate";

const TemplatePreview = () => {
    const DATA = JSON.parse(sessionStorage.getItem("template"))

    if (!DATA) {
        return <p className="text-gray-500">No Template Selected yet.</p>;
    }

    return (
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
               <WebsiteTemplate element={DATA} selectedValue={DATA} onChange={() => { }} />
        </div>
    );
};

export default TemplatePreview;